import { createContext, useEffect, useState } from 'react';
import {createBrowserRouter, Route, createRoutesFromElements, RouterProvider, Outlet} from  "react-router-dom"
import Home from './Home';
import NavBar from './NavBar';
import NotFound from './routes/NotFound';
import Documentation from './routes/Documentation';
import Download from './routes/Download';
import Contact from './routes/Contact';
import Resources from './routes/Resources';
import Sample from './routes/Sample';
import TopButton from './components/TopButton';
import download from "./assets/download1.png"
import kari from "./assets/kariLogo.png"
import Footer from './components/Footer';
import Loader from './components/Loader';


interface storeI{
  download?: string;
  kari?: string;
}
export const Store = createContext<storeI | null>(null)

export const Layout = () => {
  const [loaderState, setLoaderState] = useState(true);

  const imageLoader = (src: string) => new Promise((resolve)=> {
    const image = new Image()
    image.src = src
    image.onload = resolve
  })

  useEffect(() =>{
    Promise.all([imageLoader(download), imageLoader(kari)])
    .then(() => [
      setTimeout(() => setLoaderState(false), 1000)
    ])
  },[])
  return loaderState ? <Loader/> : (
    <>
    <NavBar/>
    <TopButton/>
    <main>
      <Outlet/>
    </main>
    <Footer/>
    </>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
    <Route path="/" element={ <Layout/> }>
      <Route index element={ <Home />}/>
      <Route path="/home" element={ <Home />}/>
      <Route path="/downloads" element={ <Download />}/>
      <Route path="/contacts" element={ <Contact />}/>
      <Route path="/resources" element={ <Resources />}/>
      <Route path="/documentation" element={ <Documentation />}/>
      <Route path="/docs" element={ <Sample/>}/>
    </Route>
    <Route path="*" element={ <NotFound/>}/>
    </>
  )
)
function App() {
  return (
    <Store.Provider value={{download, kari}}>
    <RouterProvider router={ router}/>
    </Store.Provider>
  );
}

export default App;
